@if (content && content.mobileImage && (app.client.isS || app.client.isM)) {
<div class="m-b-6">
    <df-image-wrapper>
        <img [ratio]="content.mobileImageRatio || '16/9'"
             [dfImage]="content.mobileImage" />
    </df-image-wrapper>
</div>
}

<div class="wrap-m wrap-s">
    <login-form-retail [content]="content"
                       *ifNotTradeStore />

    <login-form-trade [content]="content"
                      *ifTradeStore />
</div>